import { LinkButton, TooltipDesktop } from '@cian/ui-kit';
import { IconFileDocument16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { ControlWrapper } from '../../../../components/ControlWrapper';
import { useOfferContext } from '../../../../context';
import { selectEarlyAccessContactsFlowEnabled } from 'shared/selectors/earlyAccess/selectEarlyAccessContactsFlowEnabled';

export function DownloadPDFControlContainer() {
  const {
    user: { isAuthenticated },
    offer: { fullUrl, isEarlyAccessEnabled },
    tracking: { trackPDFLinkClicked },
    api: { openAuthenticationPopup },
  } = useOfferContext();

  const isEarlyAccessContactsFlowEnabled =
    // TODO: Удалить фича-тоггл
    useSelector(selectEarlyAccessContactsFlowEnabled) && isEarlyAccessEnabled;

  const url = React.useMemo(() => {
    if (!isAuthenticated) {
      return undefined;
    }

    return fullUrl.replace('.ru/', '.ru/export/pdf/');
  }, [isAuthenticated, fullUrl]);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    if (!url) {
      window.open(fullUrl.replace('.ru/', '.ru/export/pdf/'), '_blank');
    }

    trackPDFLinkClicked();
  };

  const handleOpenAuth = React.useCallback(
    async (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.stopPropagation();
      if (!isAuthenticated) {
        openAuthenticationPopup({
          onSuccess: () => () => handleClick(e),
        });
      } else {
        handleClick(e);
      }
    },
    [isAuthenticated],
  );

  if (isEarlyAccessContactsFlowEnabled) {
    return null;
  }

  return (
    <ControlWrapper>
      <TooltipDesktop theme="black" placement="left" title="Скачать PDF">
        <LinkButton
          data-mark="DownloadPDFControl"
          target="_blank"
          size="XS"
          theme="stroke_secondary"
          onClick={handleOpenAuth}
          href={url}
          beforeIcon={<IconFileDocument16 />}
        />
      </TooltipDesktop>
    </ControlWrapper>
  );
}
